module.exports = __webpack_public_path__ + "static/media/chess.53a3cc90.png";